export default "__VITE_ASSET__BrwizaPY__"